import React from 'react'
import { IconProps } from './icons.models'

export const StatusPending = ({
    width = 16,
    height = 16,
    className,
    onClick,
    fillColor = '#9810FA'
}: IconProps) => {
    return (
        <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} onClick={onClick}>
            <g clipPath="url(#clip0_1925_14736)">
                <path d="M8.0026 14.6663C11.6845 14.6663 14.6693 11.6816 14.6693 7.99967C14.6693 4.31778 11.6845 1.33301 8.0026 1.33301C4.32071 1.33301 1.33594 4.31778 1.33594 7.99967C1.33594 11.6816 4.32071 14.6663 8.0026 14.6663Z" stroke={fillColor} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 5.33301V7.99967" stroke={fillColor} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 10.667H8.00667" stroke={fillColor} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_1925_14736">
                    <rect width={width} height={height} fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
